export default "__VITE_ASSET__C8P_tNap__"